/* Fabric Alex product gallery stability layer v2.
   Keeps the mobile gallery swipeable and lets Warehouse own variant media
   switching without competing layout repairs. */
(function () {
  'use strict';

  var body = document.body;
  if (!body || !body.classList.contains('template-product')) return;
  if (!window.matchMedia('(max-width: 800px), (pointer: coarse)').matches) return;

  function injectStyles() {
    if (document.getElementById('fa-product-gallery-stability-styles')) return;

    var style = document.createElement('style');
    style.id = 'fa-product-gallery-stability-styles';
    style.textContent = [
      '@media screen and (max-width:800px) {',
      '  .template-product .product-gallery__carousel,',
      '  .template-product .product-gallery__carousel .flickity-viewport {',
      '    touch-action: pan-y !important;',
      '    -webkit-tap-highlight-color: transparent !important;',
      '  }',
      '  .template-product .product-gallery__carousel,',
      '  .template-product .product-gallery__carousel .flickity-viewport,',
      '  .template-product .product-gallery__carousel .flickity-slider {',
      '    width: 100% !important;',
      '    min-width: 100% !important;',
      '    max-width: none !important;',
      '    margin-right: 0 !important;',
      '    margin-left: 0 !important;',
      '  }',
      '  .template-product .product-gallery__carousel .flickity-slider {',
      '    will-change: transform !important;',
      '    -webkit-backface-visibility: hidden !important;',
      '    backface-visibility: hidden !important;',
      '  }',
      '  .template-product .product-gallery__carousel-item {',
      '    width: 100% !important;',
      '    min-width: 100% !important;',
      '    max-width: 100% !important;',
      '    margin: 0 !important;',
      '    padding: 0 !important;',
      '  }',
      '  .template-product .product-gallery__size-limiter,',
      '  .template-product .fa-product-gallery__media {',
      '    width: 100% !important;',
      '    min-width: 100% !important;',
      '    max-width: none !important;',
      '    margin: 0 !important;',
      '  }',
      '  .template-product .product-gallery__carousel-item,',
      '  .template-product .fa-product-gallery__media,',
      '  .template-product .product-gallery__image {',
      '    -webkit-backface-visibility: hidden !important;',
      '    backface-visibility: hidden !important;',
      '  }',
      '  .template-product .product-gallery__image {',
      '    pointer-events: none !important;',
      '    user-select: none !important;',
      '    -webkit-user-select: none !important;',
      '    -webkit-user-drag: none !important;',
      '    transition: none !important;',
      '    animation: none !important;',
      '  }',
      '  .template-product .product-gallery__carousel-item,',
      '  .template-product .product-gallery__thumbnail {',
      '    transition: none !important;',
      '  }',
      '  .template-product .product-gallery__thumbnail {',
      '    transform: none !important;',
      '  }',
      '  .template-product .fa-variant-gallery-switching .product-gallery__carousel-wrapper {',
      '    transition: none !important;',
      '  }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function setGeometry(el, properties) {
    if (!el) return;
    Object.keys(properties).forEach(function (property) {
      el.style.setProperty(property, properties[property], 'important');
    });
  }

  function normalizeMobileGeometry(section) {
    if (!section) return;

    var carousel = section.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    var viewport = carousel.querySelector('.flickity-viewport');
    var slider = carousel.querySelector('.flickity-slider');

    [carousel, viewport, slider].forEach(function (element) {
      setGeometry(element, {
        width: '100%',
        'min-width': '100%',
        'max-width': 'none',
        'margin-right': '0',
        'margin-left': '0'
      });
    });

    Array.prototype.forEach.call(carousel.querySelectorAll('.product-gallery__carousel-item'), function (slide) {
      setGeometry(slide, {
        width: '100%',
        'min-width': '100%',
        'max-width': '100%',
        margin: '0',
        padding: '0'
      });

      var limiter = slide.querySelector('.product-gallery__size-limiter');
      var media = slide.querySelector('.fa-product-gallery__media');

      [limiter, media].forEach(function (element) {
        setGeometry(element, {
          width: '100%',
          'min-width': '100%',
          'max-width': 'none',
          margin: '0'
        });
      });
    });

    if (window.Flickity && typeof window.Flickity.data === 'function') {
      var instance = window.Flickity.data(carousel);
      if (instance && typeof instance.resize === 'function') {
        window.requestAnimationFrame(function () {
          instance.resize();
        });
      }
    }
  }

  function forceStableSettings(section) {
    if (!section) return;
    var raw = section.getAttribute('data-section-settings');
    if (!raw) return;

    try {
      var settings = JSON.parse(raw);
      settings.enableImageZoom = false;
      settings.infoOverflowScroll = false;
      settings.galleryTransitionEffect = 'slide';
      section.setAttribute('data-section-settings', JSON.stringify(settings));
    } catch (error) {
      /* A third-party app may alter this JSON. Keep the page usable. */
    }
  }

  function disconnectObserver(owner, property) {
    if (!owner || !owner[property]) return;
    try {
      owner[property].disconnect();
    } catch (error) {}
  }

  function disconnectHeavyObservers(section) {
    if (!section) return;

    disconnectObserver(section, '__faPdpV9Observer');
    disconnectObserver(section, '__faPdpV8Observer');
    disconnectObserver(section, '__faPdpV7Observer');
    disconnectObserver(section, '__faGapV10Observer');

    var carousel = section.querySelector('.product-gallery__carousel');
    var list = section.querySelector('.product-gallery__thumbnail-list');

    disconnectObserver(carousel, '__faProductCounterObserver');
    disconnectObserver(list, '__faThumbnailObserver');
  }

  function visibleSlides(carousel) {
    return Array.prototype.filter.call(
      carousel ? carousel.querySelectorAll('.product-gallery__carousel-item') : [],
      function (item) {
        return !item.classList.contains('is-filtered') && item.style.display !== 'none';
      }
    );
  }

  function activeMediaId(section) {
    var selected = section.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)');
    return selected ? (selected.getAttribute('data-media-id') || '') : '';
  }

  function syncCounter(section) {
    var carousel = section.querySelector('.product-gallery__carousel');
    var counter = section.querySelector('.fa-product-gallery-counter');
    if (!carousel || !counter) return;

    var slides = visibleSlides(carousel);
    var selected = carousel.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)');
    var index = selected ? slides.indexOf(selected) : 0;
    if (index < 0) index = 0;

    counter.textContent = (index + 1) + ' / ' + slides.length;
    counter.hidden = slides.length < 2;
  }

  function syncThumbnails(section) {
    var list = section.querySelector('.product-gallery__thumbnail-list');
    if (!list) return;

    var id = activeMediaId(section);
    var thumbs = list.querySelectorAll('.product-gallery__thumbnail');

    Array.prototype.forEach.call(thumbs, function (thumb) {
      var active = !!id && thumb.getAttribute('data-media-id') === id && !thumb.classList.contains('is-filtered');

      if (active) {
        thumb.classList.add('is-nav-selected');
        thumb.style.setProperty('opacity', '1', 'important');
        thumb.style.setProperty('box-shadow', '0 0 0 2px #fff, 0 0 0 4px #0b3155', 'important');
        thumb.style.setProperty('border', '1px solid rgba(49,88,123,.78)', 'important');
        thumb.style.setProperty('transform', 'none', 'important');
      } else {
        thumb.classList.remove('is-nav-selected');
        thumb.style.setProperty('opacity', thumb.classList.contains('is-filtered') ? '0' : '1', 'important');
        thumb.style.setProperty('box-shadow', 'none', 'important');
        thumb.style.setProperty('border', '1px solid rgba(19,44,68,.20)', 'important');
        thumb.style.setProperty('transform', 'none', 'important');
      }
    });
  }

  function syncSelectionUi(section) {
    if (!section) return;
    syncCounter(section);
    syncThumbnails(section);
  }

  function installLightSelectionObserver(section) {
    if (!section || section.__faStableSelectionObserver) return;

    var carousel = section.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    var queued = false;
    var observer = new MutationObserver(function (mutations) {
      var changed = false;

      for (var i = 0; i < mutations.length; i += 1) {
        var target = mutations[i].target;
        if (target && target.classList && target.classList.contains('product-gallery__carousel-item')) {
          changed = true;
          break;
        }
      }

      if (!changed || queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        syncSelectionUi(section);
      });
    });

    observer.observe(carousel, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    section.__faStableSelectionObserver = observer;
  }

  function lockGalleryHeight(section) {
    if (!section) return;
    var wrapper = section.querySelector('.product-gallery__carousel-wrapper');
    if (!wrapper) return;

    var rect = wrapper.getBoundingClientRect();
    if (!rect.height || rect.height < 40) return;

    wrapper.style.setProperty('min-height', Math.ceil(rect.height) + 'px', 'important');
    section.classList.add('fa-variant-gallery-switching');
  }

  function unlockGalleryHeight(section) {
    if (!section) return;
    var wrapper = section.querySelector('.product-gallery__carousel-wrapper');
    if (wrapper) wrapper.style.removeProperty('min-height');
    section.classList.remove('fa-variant-gallery-switching');
  }

  function settleVariant(section) {
    if (!section) return;

    disconnectHeavyObservers(section);
    syncSelectionUi(section);

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        unlockGalleryHeight(section);
      });
    });
  }

  function stabilize(section) {
    if (!section) return;
    forceStableSettings(section);
    normalizeMobileGeometry(section);
    disconnectHeavyObservers(section);
    installLightSelectionObserver(section);
    syncSelectionUi(section);

    var carousel = section.querySelector('.product-gallery__carousel');
    if (carousel && !carousel.__faStablePointerHandlers) {
      var finish = function () {
        window.setTimeout(function () { syncSelectionUi(section); }, 35);
        window.setTimeout(function () { syncSelectionUi(section); }, 140);
      };

      carousel.addEventListener('pointerdown', function () {
        disconnectHeavyObservers(section);
      }, { passive: true });
      carousel.addEventListener('pointerup', finish, { passive: true });
      carousel.addEventListener('pointercancel', finish, { passive: true });
      carousel.__faStablePointerHandlers = true;
    }
  }

  function stabilizeAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="product"]'), stabilize);
  }

  function sectionFromVariantEvent(event) {
    var target = event && event.target;
    if (target && target.closest) {
      var section = target.closest('[data-section-type="product"]');
      if (section) return section;
    }
    return document.querySelector('[data-section-type="product"]');
  }

  injectStyles();

  /* Runs before Warehouse's deferred product script so Flickity initializes
     with slide transitions and zoom disabled. */
  stabilizeAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      stabilizeAll();
      window.setTimeout(stabilizeAll, 0);
      window.setTimeout(stabilizeAll, 120);
    });
  }

  /* Warehouse handles filtering, Flickity reactivation and featured-media
     selection. We only hold the current gallery height during that native
     rebuild, then perform one lightweight visual sync after it has settled. */
  document.addEventListener('variant:changed', function (event) {
    var section = sectionFromVariantEvent(event);
    if (!section) return;

    lockGalleryHeight(section);

    if (section.__faVariantSettleTimer) {
      window.clearTimeout(section.__faVariantSettleTimer);
    }

    section.__faVariantSettleTimer = window.setTimeout(function () {
      section.__faVariantSettleTimer = null;
      settleVariant(section);
    }, 160);
  });

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(stabilizeAll, 0);
    window.setTimeout(stabilizeAll, 150);
  });

  /* Catch observers created by the older scripts during their delayed initial
     setup passes. No recurring work remains after this startup window. */
  window.setTimeout(stabilizeAll, 250);
  window.setTimeout(stabilizeAll, 700);
  window.setTimeout(stabilizeAll, 1400);
  window.setTimeout(stabilizeAll, 2800);
})();